import request from '@/utils/request'

// 查询用户报告主记录列表
export function listReportUserTotal(query) {
    return request({
        url: '/biz/reportUserTotal/list',
        method: 'get',
        params: query
    })
}

// 查询用户报告主记录详细
export function getReportUserTotal(id) {
    return request({
        url: '/biz/reportUserTotal/' + id,
        method: 'get'
    })
}
// 查询用户报告主记录详细
export function getUserReport(userId) {
    return request({
        url: '/biz/reportUserTotal/getUserReport?userId=' + userId,
        method: 'get'
    })
}
// 查询用户报告主记录详细
export function getUserReportWithTemplate(userId) {
    return request({
        url: '/biz/reportUserTotal/getUserReportWithTemplate?userId=' + userId,
        method: 'get'
    })
}

// 新增用户报告主记录
export function addReportUserTotal(data) {
    return request({
        url: '/biz/reportUserTotal',
        method: 'post',
        data: data
    })
}

// 修改用户报告主记录
export function updateReportUserTotal(data) {
    return request({
        url: '/biz/reportUserTotal/update',
        method: 'post',
        data: data
    })
}

// 删除用户报告主记录
export function delReportUserTotal(id) {
    return request({
        url: '/biz/reportUserTotal/delete/' + id,
        method: 'post'
    })
}

// 查询模板列表
export function listReportTemplateDetail(query) {
  return request({
      url: '/biz/reportTemplate/listAll',
      method: 'get',
      params: query
  })
}

// 读取模板字段数据 
export function getHisReportResult(query) {
  return request({
      url: '/biz/reportTemplate/getHisReportResult',
      method: 'get',
      params: query
  })
}

// 获取指定检测的结果数据 
export function getHisReportAttributeResult(query) {
  return request({
      url: '/biz/reportTemplate/getHisReportAttributeResult',
      method: 'get',
      params: query
  })
}


// 获取报告数据详情 
export function getReportTotalById(id) {
  return request({
      url: '/biz/reportUserTotal/getReportTotalById?reportTotalId=' + id,
      method: 'get',
  })
}



// 保存报告数据
export function saveOrUpdate(data) {
  return request({
      url: '/biz/reportUserTotal/saveOrUpdate',
      method: 'post',
      data: data
  })
}
